import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { Math as ThreeMath } from 'three'
import { useFrame } from 'react-three-fiber'
import { Model } from '../../three'
import { useSpring } from 'react-spring/three'

const ModelViewerModel = ({
  rotation: initialRotation,
  model: active,
  autoRotate,
  onRotate,
  ...props
}) => {
  // spring to manage rotation and animate it
  const [{ rotation }, setRotation] = useSpring(() => ({
    rotation: initialRotation
  }))

  // update rotation when new value provided
  useEffect(
    () => void setRotation({ rotation: initialRotation }),
    [initialRotation, setRotation]
  )

  // rotate the model if auto rotate is on
  useFrame(() => {
    if (!autoRotate) return
    onRotate(
      [
        initialRotation[0],
        initialRotation[1] + 1,
        initialRotation[2]
      ],
      false
    )
  })

  return (
    <Model
      position={active.position}
      rotation={rotation.interpolate((x, y, z) => [
        ThreeMath.degToRad(x),
        ThreeMath.degToRad(y),
        ThreeMath.degToRad(z)
      ])}
      type="gltf"
      url={active.model}
      {...props}
    />
  )
}

ModelViewerModel.propTypes = {
  rotation: PropTypes.array
}

export default ModelViewerModel
